import * as Yup from 'yup';
import { MaxValidation } from './max-validation';
import { MinValidation } from './min-validation';
import { PositiveValidation } from './positive-validation';
import { RequiredValidation } from './required-validation';
import { MatchesValidation } from './matches-validation';
import { EmailValidation } from './email-validation';
import { TemplateFormFieldValidationType } from '../../interfaces/template-form-validation';
import { TemplateFormFieldValidation } from '../../interfaces/template-form';

export const TEMPLATE_FORM_FIELD_VALIDATION_REGISTRY: Record<
  TemplateFormFieldValidationType,
  (validator: Yup.Schema<unknown>, validation: TemplateFormFieldValidation) => Yup.Schema<unknown>
> = {
  [TemplateFormFieldValidationType.MAX]: MaxValidation,
  [TemplateFormFieldValidationType.MIN]: MinValidation,
  [TemplateFormFieldValidationType.POSITIVE]: PositiveValidation,
  [TemplateFormFieldValidationType.REQUIRED]: RequiredValidation,
  [TemplateFormFieldValidationType.MATCHES]: MatchesValidation,
  [TemplateFormFieldValidationType.EMAIL]: EmailValidation
};
